module.exports = __webpack_public_path__ + "img/dg_icon_2.e0879a4d.png";